import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setSuccessfulAttempt,
} from '../../procedures/woundCare/store/woundCare.actions'
import { setAddWoundCareToTimeline } from '../store/quickActions.actions'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'

export function* setWoundCareQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAddWoundCareToTimeline(true))
}

export function* setWoundCareQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_WOUND_CARE_BUTTON_TYPE], setWoundCareQuickAction)
}
